<template>
    <div class="animated fadeIn">
        <b-container>
            <b-row>
                <b-col sm="12" md="4">
                    <iframe
                        src="https://masterworks.looker.com/embed/dashboards/135"
                        :height="iFrameHeight"
                        :width="iFrameWidth"
                        frameborder="0">
                    </iframe>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
export default {
  name: 'lookerstatistics',
  data: function () {
    const now = Math.round(Date.now() / 1000)

    return {
      iFrameWidth: 1130,
      iFrameHeight: 500,
      finishedLoading: false,
      spinnerColor: '#0F347B',
      spinnerSize: '50px',
      expandState: false,
      startedLoading: now
    }
  },
  methods: {
    handleIframeEvent: function (event) {
      if (typeof event.data === 'string') {
        var data = JSON.parse(event.data)
        if (data.type === 'page:properties:changed') {
          this.handlePagePropertiesEvent(data)
        }
        if (data.type === 'dashboard:tile:complete') {
          this.handleTileCompletedEvent(data)
        }
      }
    },
    handlePagePropertiesEvent: function (data) {
      this.iFrameHeight = data.height
    },
    handleTileCompletedEvent: function (data) {
      this.finishedLoading = true
      if (!_.isUndefined(window._paq) && data.tile) {
        const now = Math.round(Date.now() / 1000)
        const duration = now - this.startedLoading
        const tileName = data.tile.id + ' - ' + data.tile.title
        console.log('Tile ' + tileName + ' loaded in ' + duration + ' seconds')
        window._paq.push([ 'trackEvent', 'LookerTileLoaded', tileName, duration ])
      }
    },
    handleResize: function (event) {
      let width = window.innerWidth
      this.iFrameWidth = width
    }
  },
  mounted () {
    window.addEventListener('message', this.handleIframeEvent.bind(this))
    window.addEventListener('resize', this.handleResize.bind(this))
  },
  beforeDestroy () {
    window.removeEventListener('message', this.handleIframeEvent)
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>


// WEBPACK FOOTER //
// src/views/t1/LookerStatistics.vue